import { FC, useState } from 'react';
import { ComuniTopic } from '../../constants';
import { SYSTEM_MODELS, SystemModel } from '../../templates/catalog';
import { SystemModelStatus } from '../../templates/modelStatus';
import type { WorkspaceTemplateRow } from '../../templates/partitionWorkspaceTemplates';
import { CustomModelRow } from './CustomModelRow';
import { SystemModelRow } from './SystemModelRow';
import { TopicModelsSection } from './TopicModelsSection';

/** Topics present in the catalog, in catalog order. */
const MODEL_TOPICS = [...new Set(SYSTEM_MODELS.map((model) => model.topic))];

type ModelliTabContentProps = {
  statusById: Map<string, SystemModelStatus>;
  statusSkeleton: boolean;
  customsByTopic: Map<ComuniTopic, WorkspaceTemplateRow[]>;
  onPreviewSystem: (model: SystemModel) => void;
  onPreviewCustom: (row: WorkspaceTemplateRow) => void;
  onCustomize: (model: SystemModel) => void;
  onEditCustom: (row: WorkspaceTemplateRow) => void;
  onDeleteCustom: (row: WorkspaceTemplateRow) => void;
};

export const ModelliTabContent: FC<ModelliTabContentProps> = ({
  statusById,
  statusSkeleton,
  customsByTopic,
  onPreviewSystem,
  onPreviewCustom,
  onCustomize,
  onEditCustom,
  onDeleteCustom,
}) => {
  const [openTopics, setOpenTopics] = useState<ComuniTopic[]>([MODEL_TOPICS[0]]);

  const toggleTopic = (topic: ComuniTopic) =>
    setOpenTopics((current) => (current.includes(topic) ? current.filter((item) => item !== topic) : [...current, topic]));

  return (
    <div className='grid min-w-0 grid-cols-1 gap-3'>
      {MODEL_TOPICS.map((topic) => {
        const models = SYSTEM_MODELS.filter((model) => model.topic === topic);
        const customs = customsByTopic.get(topic) ?? [];
        const isOpen = openTopics.includes(topic);
        const count = models.length + customs.length;
        return (
          <TopicModelsSection key={topic} topic={topic} count={count} isOpen={isOpen} onToggle={() => toggleTopic(topic)}>
            {models.map((model) => (
              <SystemModelRow
                key={model.id}
                model={model}
                status={statusById.get(model.id)}
                statusSkeleton={model.channel === 'whatsapp' && statusSkeleton}
                onPreview={onPreviewSystem}
                onCustomize={onCustomize}
              />
            ))}
            {customs.map((row) => (
              <CustomModelRow
                key={row.id}
                row={row}
                onPreview={onPreviewCustom}
                onEdit={onEditCustom}
                onDelete={onDeleteCustom}
              />
            ))}
          </TopicModelsSection>
        );
      })}
    </div>
  );
};
